module.exports = __webpack_public_path__ + "static/media/hyperthermia_good.e47d03e5.svg";